import React, { useState, useEffect} from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import NestedAccordion from './ledgerAccordian';

const PaymentReceive = () => {
	
    const [formData, setFormData] = useState([{ date: '', code: '', party: '', amount: '', acc:'', note: '', ledger: '', ledgerName: '' }]);
    const [edit, setEdit] = useState(0);
    const [selectDealer, setSelectDealer] = useState(false);
    const [openLedger, setOpenLedger] = useState(null);
	const [ledgers, setLedger] = useState([]);
	const [uploading, setUploading] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const [dealerData, setDealerData] = useState(null);
	const [selectedItem, setSelectedItem] = useState({
		master: "",
        mainGroup: "",
        subGroup: "",
	});

	useEffect(() => {
        setSelectedItem({
            master: "",
            mainGroup: "",
            subGroup: "",
        });
    },[openLedger]);
	
	const handleSelectLedger = (data) => {
		setSelectedItem(data);
		setFormData(prev =>
            prev.map((row, i) =>
                i === openLedger ? { ...row, ['ledger']: data } : row
            )
        );
	};

	console.log(formData);
	
	
	const handleChange = (index, e) => {
	    const { name, value } = e.target;
	    setFormData(prev =>
            prev.map((row, i) =>
                i === index ? { ...row, [name]: value } : row
            )
        );

		if(name === 'party'){
			const selectedDealer = dealerData?.filter(dealer => dealer.dealer === value)[0];
			if(selectedDealer){
				setFormData(prev =>
					prev.map((row, i) =>
						i === index ? { ...row, ['code']: selectedDealer.id } : row
					)
				);
			}
		}

		if(name === 'ledgerName'){
			const [masterId, mainGroupId, subGroupId] = value.split(" | ");
			setFormData(prev =>
				prev.map((row, i) =>
					i === index ? { ...row, ['ledgerName']: subGroupId } : row
				)
			);
			ledgers?.forEach(master => {
				if(master.masterName === masterId){
					master.main.forEach(mainGroup => {
						if(mainGroup.mainGroupName === mainGroupId){
							mainGroup.sub.forEach(subGroup => {
								if(subGroup.subGroupName === subGroupId){
									setFormData(prev =>
										prev.map((row, i) =>
											i === index ? { ...row, ['ledger']: {
												master: master.id,
												mainGroup: mainGroup.id,
												subGroup: subGroup.id
											} } : row
										)
									);
								}
							});
						}
					});
				}
			});
		}
	};

	const getLedger = async () => {
		try {
		const response = await axios.get(
			"https://api.trucoo.in/ledger/",
			{
			headers: {
				"Content-Type": "application/json",
				"X-API-KEY": "erpTrucoo",
			},
			}
		);

		if (response.data.status === "success") {
			setLedger(response.data.data);
		}
		} catch (error) {
		console.error(error);
		}
	};

	const checkEmptyFields = (data) => {
        for (let i = 0; i < data.length; i++) {
            const row = data[i];
            if (!row.date || !row.code || !row.party || !row.amount || !row.acc || !row.ledger) {
                return false; // Found an empty field
            }
        }
        return true; // All fields are filled
    };

    const uploadData = async () => {

        setUploading(true);

        const isAllFieldsFilled = checkEmptyFields(formData);
        if (!isAllFieldsFilled) {
            alert("Please fill all fields before uploading.");
            setUploading(false);
            return;
        }

        try {
            const response = await axios.post("https://api.trucoo.in/payment/upload/", formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                },
            });

			// console.log(response.data);

            if (response.data.status === "success") {
                alert("Data uploaded successfully!");
                setFormData([{ date: '', code: '', party: '', amount: '', acc:'', note: '', ledger: '', ledgerName: '' }]);
            } else {
                alert("Failed to upload data. Please try again.");
            }
           
        } catch (error) {
            console.error(error);
        }

        setUploading(false);

    };


	const getDealerData = async () => {
		try {
			const response = await axios.get('https://api.trucoo.in/dealers/view/', {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				setDealerData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const filteredOptions = dealerData && dealerData?.filter(option =>
		option.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
		option.dealer.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const handleSelect = (index, code, party) => {
		setFormData(prev =>
			prev.map((row, i) =>
				i === index
					? { ...row, party, code }
					: row
			)
		);

		setSelectDealer(false);
	};


	useEffect(() => {
		getDealerData();
		getLedger();
	},[]);

	const AddNewEntry = () => {
		setFormData(prev =>
			[...prev,
			{ date: '', code: '', party: '', amount: '', acc:'', note: '', ledger: ''}]
		);
		setEdit(formData?.length || 0);
	};

	const getLedgerDetails = (data) => {

        if (!data?.master) return "";
        const master = ledgers?.find(l => l.id === data.master);
        if (!master) return "";
        let text = master.masterName;
        if (data.mainGroup) {
            const main = master.main?.find(m => m.id === data.mainGroup);
            text += main ? ` / ${main.mainGroupName}` : "";
            if (data.subGroup) {
                const sub = main?.sub?.find(s => s.id === data.subGroup);
                text += sub ? ` / ${sub.subGroupName}` : "";
            }
        }
        return text;
    };

	let totalAmount = 0;

	return (

		<>
			<Header />
			<Sidebar />

			<div class="content-wrapper">
				<div class="container-full">
					<section class="content">
						<div class="row">
							<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
								<div class="box">
									<div class="box-body">
										<h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Payment Receive</h4>
										<div align="right" style={{marginTop: '-30px'}}>
											<button className='btn btn-warning' onClick={uploadData}>Upload Data</button>
										</div>
										<hr class="my-15" />
										<div class="row">

											<div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 240px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
												<div className="table-responsive">
													<table className="table-sm fs-12 text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
														<thead>
															<tr >
																<th className='text-center'>S.No</th>
																<th>Date</th>
																<th className='text-center'>Code</th>
																<th>Party Name</th>
																<th className='text-end'>Amount</th>
																<th>Ledger</th>
																<th>Ref.No</th>
																<th>Narration</th>
																<th>Edit</th>
															</tr>
														</thead>
														<tbody>
															{formData?.map((trans, index) =>{
																totalAmount += parseFloat(trans?.amount ||0);
																const ledger = getLedgerDetails(trans?.ledger);
															  return(
																<tr className={edit === index && 'bg-dark'}>
																	<td className='text-center'>{index+1}</td>
																	<td>
																		{edit === index ?
																			<input type="date" className='form-control' name="date" value={trans?.date} onChange={(e)=> handleChange(index, e)} />
																		:
																			trans?.date
																		}
																	</td>
																	{edit !== index &&
																		<td className='text-center'>{trans?.code}</td>
																	}
																	<td colSpan={edit === index ? 2 : 1}>
																		{edit === index ?
																		<>
																			<input className="form-control"  type="text" list="products" placeholder="Select Party..." name="party" value={trans?.party} onChange={(e)=> handleChange(index, e)} />
																			<datalist id="products">
																				{dealerData?.map((dealers, index) => 
																					<option key={index} value={dealers.dealer}></option>
																				)}
																			</datalist>
																		</>
																			// selectDealer === index ?
																			// 	<div class="popup-overlay">
																			// 		<div class="popup">
																			// 			<div class="form-group">
																							
																			// 				<div className="select-container">
																			// 					<div className="dropdown" style={{ maxHeight: '900px', overflowY: 'auto', marginTop: '5px', border: '1px solid #333', padding: '5px', borderRadius: '10px' }}>
																			// 						<label class="form-label text-dark mt-3">Select Party</label>
																			// 						<button style={{float: 'right', margin: '10px'}} className="btn btn-sn btn-danger" onClick={()=> setSelectDealer(null)} ><i className="fa fa-close"></i></button>
																			// 					<input type="text" className="form-control mt-2" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ padding: '5px', width: '100%', border: '1px solid #6c6c6c' }} />
																			// 						<div className="options" style={{ maxHeight: '400px', overflowY: 'auto' }}>
																			// 							{filteredOptions?.length === 0 ? (
																			// 								<div className="no-options">No matching options</div>
																			// 							) : (
																			// 							filteredOptions?.map((option, patyIndex) => (
																			// 								<button key={patyIndex} className={option.id === trans?.code ? 'form-control mt-2 bg-primary' : 'form-control mt-2'} onClick={() => handleSelect(index, option.id, option.dealer)} >
																			// 									{option.dealer}
																			// 								</button>
																			// 							))
																			// 							)}
																			// 						</div>
																			// 					</div>
																			// 				</div>
																			// 			</div>
																			// 		</div>
																			// 	</div>
																			// : 
																			// 	<button className="btn btn-sm btn-warning" onClick={()=> setSelectDealer(index)} > { trans?.party.length > 0 ? trans?.party : 'Select Party' }</button>
																		:
																			trans?.party
																		}
																	</td>
																	<td  align="right">
																		{edit === index ?
																			<input className='form-control text-end' name="amount" value={trans?.amount} onChange={(e)=> handleChange(index, e)} />
																		:
																			trans?.amount
																		}
																	</td>
																	<td>
																		{edit === index ?
																		<>
																			<input className="form-control fs-10"  type="text" list="ledgers" placeholder="Select Ledger..." name="ledgerName" value={trans?.ledgerName} onChange={(e)=> handleChange(index, e)} />
																			<datalist id="ledgers">
																				{ledgers?.map(ledger=> 
																					ledger?.main?.map(mainGroup =>
																						mainGroup?.sub?.map(subGroup =>
																							<option
																								key={subGroup.id}
																								value={`${ledger.masterName} | ${mainGroup.mainGroupName} | ${subGroup.subGroupName}`}
																							>
																								{subGroup.subGroupName}
																							</option>
																						)
																					)
																				)}
																			</datalist>
																		</>
																			// openLedger === index ?
																			// 	<div class="popup-overlay">
																			// 		<div class="popup">
																			// 			<div style={{minHeight: '200px', maxHeight: '90vh', overflowY: 'auto'}}>
																			// 				<h4 className="text-dark">Select Ledger</h4>
																			// 				{ledgers?.length > 0 &&
																			// 					<NestedAccordion
																			// 						selectedItem={selectedItem}
																			// 						onSelect={handleSelectLedger}
																			// 						ledgers={ledgers}
																			// 						close={setOpenLedger}
																			// 					/>
																			// 				}
																			// 			</div>
																			// 		</div>
																			// 	</div>
																			// : 
																			// 	<button className="btn btn-sm btn-warning" onClick={()=> setOpenLedger(index)} > { ledger ? ledger : 'Select Ledger' }</button>
																		:
																			ledger
																		}
																	</td>
																	<td className='fs-10'>
																		{edit === index ?
																			<input className='form-control' name="acc" value={trans?.acc} onChange={(e)=> handleChange(index, e)} />
																		:
																			trans?.acc
																		}
																	</td>
																	<td className='fs-10'>
																		{edit === index ?
																			<input className='form-control' name="note" value={trans?.note} onChange={(e)=> handleChange(index, e)} />
																		:
																			trans?.note
																		}
																	</td>
																	<td>
																		{edit === index ?
																			<button className='btn btn-sm btn-primary' onClick={()=>setEdit(null)}><i className='fa fa-save'></i></button>
																		:
																			<button className='btn btn-sm btn-danger' onClick={()=>setEdit(index)}><i className='fa fa-edit'></i></button>
																		}
																	</td>
																</tr>
															  )}
															)}
															<tr>
																<td colSpan={8}></td>
																<td><button className='btn btn-sm btn-primary' onClick={AddNewEntry} ><i className="fa fa-plus"></i></button></td>
															</tr>
															<tr>
																<td colSpan={4}></td>
																<td className="text-end">{parseFloat(totalAmount).toFixed(2)}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</>
	)


}

export default PaymentReceive;